// TODO: Abstract the use of these images to use vector-image service
import iconImage from './assets/Treasure.png';

const { host } = window.location;
let domain = host;
if (host !== 'deckee.com') domain = 'staging.deckee.com';

export default {
  displayName: 'Treasure',
  iconImage,
  subscriberOnly: true,
  iconBackgroundColor: '#ADE1FE',
  style: `https://${domain}/public/map-tile-server/map-styles/treasure.json`,
};
